import { useDarkMode } from "@/hooks";
import { getIn, useFormikContext } from "formik";
import { useEffect, useState } from "react";
import ReactQuill from "react-quill";

import "react-quill/dist/quill.snow.css";

interface Props {
  name: string;
}

export const Quill = ({ name }: Props) => {
  const { values, errors, setFieldValue } = useFormikContext();
  const isDarkMode = useDarkMode();

  const fieldError = getIn(errors, name);

  const borderColour = fieldError
    ? "border-red-500"
    : "border-gray-300 dark:border-white/5";

  const [isInitialRender, setIsInitialRender] = useState(true);

  const [html, setHtml] = useState<string>(getIn(values, name) || "");

  useEffect(() => setIsInitialRender(false), []);

  // Add style overrides for Quill editor for dark and light mode
  // This ensures text color and background are correct in both modes
  const quillStyle = `
    .ql-container {
      ${!isDarkMode && "background: #fff;"}
      color: #222;
    }
    .ql-editor {
      background: transparent;
      color: inherit;
    }
  `;

  return (
    <>
      <style>{quillStyle}</style>
      {!isInitialRender && (
        <>
          <ReactQuill
            className={`w-full bg-white dark:bg-dark-secondary dark:text-gray-400 border rounded-md ${borderColour}`}
            theme="snow"
            value={getIn(values, name)}
            onChange={(value, _delta, source) => {
              if (source === "user") {
                setFieldValue(name, value);
              }
            }}
          />
        </>
      )}
      {fieldError && <p className="text-red-500 text-xs mt-2">{fieldError}</p>}
    </>
  );
};
